import Courses from './components/Courses'

export default Courses
